import gql from 'graphql-tag';

export default gql`
  mutation UpdateChannel($channel: ChannelInput!) {
    updateChannel(channel: $channel) {
      _id
    }
  }
`;
